import { canAccessDashboard } from "./dashboardRouteAccess";

export function canUseAdminCopilot(input: {
  isAuthenticated: boolean;
  tenantId?: string | null;
  isCompanyPrincipal: boolean;
  roleType?: string | null;
  permissions: readonly string[];
  adminAiAssistantEnabled?: boolean;
}): boolean {
  if (input.adminAiAssistantEnabled === false) return false;
  return (
    input.isAuthenticated &&
    Boolean(input.tenantId) &&
    (input.isCompanyPrincipal ||
      canAccessDashboard({
        roleType: input.roleType,
        permissions: input.permissions,
      }))
  );
}
